import { Suspense, lazy } from 'react'
import { Routes, Route } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Calendar from './pages/Calendar'
import Application from './pages/application'
import NotificationMessagePage from './components/notificationMessagePage'
// import InterviewStageController from './pages/interviewStageController'
import Career from './pages/Career'
import LoadingPage from './components/loadingPage'
import ApplicationProfileUpdate from './pages/ApplicationProfileUpdate'
import TalentPool from './pages/TalentPool'
import ScheduledNotification from './pages/ScheduledNotification'
import UploadRequestedDocuments from './pages/UploadRequestedDocuments'
const InterviewStageController = lazy(
  () => import('./pages/interviewStageController'),
)

function App() {
  const { t } = useTranslation()
  return (
    <Suspense fallback={<LoadingPage />}>
      <Routes>
        <Route path="/calendar/:token" element={<Calendar />} />
        <Route path="/job-application/:token" element={<Application />} />
        <Route
          path="/interview/:interviewToken"
          element={<InterviewStageController />}
        />
        <Route
          path="/scheduled-notification"
          element={<ScheduledNotification />}
        />
        <Route path="/talent-pool/:invitationLink" element={<TalentPool />} />
        <Route path="/careers/:companyId" element={<Career />} />
        <Route
          path="/application-profile-update/:token"
          element={<ApplicationProfileUpdate />}
        />
        <Route
          path="/request-documents/:token"
          element={<UploadRequestedDocuments />}
        />
        <Route
          path="*"
          element={
            <NotificationMessagePage
              messageType="error"
              message={t('pages.pageNotFound')}
            />
          }
        />
      </Routes>
    </Suspense>
  )
}
export default App
